import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

import { baseAssetWithTimeseriesSchema } from "./assetsBase";

export const overflowListItemSchema = baseAssetWithTimeseriesSchema.extend({
  name: z.string(),
  start_point: z.string().nullable() /* URL to Manhole */,
  end_point: z.string().nullable() /* URL to Manhole */,
  connection_serial: z.number().nullable(),
  angle: z.number().nullable(),
  crest_width: z.number().nullable(),
  crest_level: z.number().nullable(),
  sensor_level: z.number().nullable(),
  surface_level: z.number().nullable(),
  open_water_level_average: z.number().nullable(),
  open_water_level_summer: z.number().nullable(),
  open_water_level_winter: z.number().nullable(),
  allowed_flow_direction: z.string().nullable(),
});

export type OverflowListItem = z.infer<typeof overflowListItemSchema>;

export const overflowListSchema = paginatedSchema(overflowListItemSchema);
export type OverflowList = z.infer<typeof overflowListSchema>;

export const overflowSchema = overflowListItemSchema;
export type Overflow = z.infer<typeof overflowSchema>;

export function useOverflows(params = {}) {
  const url = combineUrlAndParams("/api/v4/overflows/", params);
  return useParsedQuery<OverflowList>(
    ["lizard-api-v4", "overflows", url],
    () => fetchWithError(url),
    (json: unknown) => overflowListSchema.parse(json)
  );
}

export function useOverflow(id: number) {
  return useParsedQuery<Overflow>(
    ["lizard-api-v4", "overflows", id],
    () => fetchWithError(`/api/v4/overflows/${id}/`),
    (json: unknown) => overflowSchema.parse(json)
  );
}

export function useMultipleOverflows(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "overflows", id],
        fetchFunction: () => fetchWithError(`/api/v4/overflows/${id}/`),
        parseFunction: (json: unknown) => overflowSchema.parse(json),
      };
    })
  );
}
